function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase()
}

function unitHasConfigId(unit, configId) {
  if (!configId || !unit) return false
  return String(unit.configId || '').toUpperCase() === String(configId).toUpperCase()
}

function hasExistingPortalAccount(authData) {
  if (authData?.user?.email) return true
  return Array.isArray(authData?.units) && authData.units.length > 0
}

/**
 * Existing Portal customers skip the new-account form and go to add-product.
 * If this QR's contract is already on the account, skip to the done screen.
 */
function chooseQuickStartStage({ authData, configId } = {}) {
  const units = authData?.units || []
  if (units.some((unit) => unitHasConfigId(unit, configId))) return 'finish'
  if (hasExistingPortalAccount(authData)) return 'add-product'
  return 'new-account'
}

export { chooseQuickStartStage, hasExistingPortalAccount, unitHasConfigId, normalizeEmail }
